import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f7c351a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tendetai",
  style: {"font-weight":"bold","width":"50vw"}
}, "Tên đề tài :", -1))
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Người thực hiện 1", -1))
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Người thực hiện 2", -1))
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Người thực hiện 3", -1))
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Lĩnh vực", -1))
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chuyên ngành", -1))
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cấp độ đề tài", -1))
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mã số đề tài", -1))
const _hoisted_19 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Nội dung:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, null, -1))
const _hoisted_22 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_23 = { class: "p-field p-col-2 p-sm-2 p-md-2" }
const _hoisted_24 = { enctype: "multipart/form-data" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_27 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_28 = { id: "adding" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang gởi đề tài, vui lòng chờ...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center"},
    header: "Thêm đề tài"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              id: "tendetai",
              type: "phone",
              modelValue: $setup.deTaiCreate.tenDeTai,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.deTaiCreate.tenDeTai) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Dropdown, {
              id: "user1",
              modelValue: $setup.idUser1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.idUser1) = $event)),
              options: $setup.listUser,
              optionLabel: "fullname",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Dropdown, {
              id: "user2",
              modelValue: $setup.idUser2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.idUser2) = $event)),
              options: $setup.listUser,
              optionLabel: "fullname",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Dropdown, {
              id: "user3",
              modelValue: $setup.idUser3,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idUser3) = $event)),
              options: $setup.listUser,
              optionLabel: "fullname",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Dropdown, {
              id: "linhvuc",
              modelValue: $setup.deTaiCreate.linhVuc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.deTaiCreate.linhVuc) = $event)),
              options: $setup.listLinhVuc,
              optionLabel: "tenLinhVuc",
              optionValue: "tenLinhVuc",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Dropdown, {
              id: "chuyennganh",
              modelValue: $setup.deTaiCreate.chuyenNganh,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.deTaiCreate.chuyenNganh) = $event)),
              options: $setup.listChuyenNganh,
              optionLabel: "tenChuyenNganh",
              optionValue: "tenChuyenNganh",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              id: "capdodetai",
              modelValue: $setup.deTaiCreate.capDoDeTai,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.deTaiCreate.capDoDeTai) = $event)),
              options: $setup.listCapDo,
              optionLabel: "capDoDeTai",
              optionValue: "capDoDeTai",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_InputText, {
              id: "masodetai",
              type: "phone",
              modelValue: $setup.deTaiCreate.maSoDeTai,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.deTaiCreate.maSoDeTai) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", null, [
              _createVNode(_component_Textarea, {
                id: "noidung",
                type: "phone",
                modelValue: $setup.deTaiCreate.noiDungDeTai,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.deTaiCreate.noiDungDeTai) = $event)),
                rows: "20"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Button, {
              class: "p-button-outlined",
              label: "Đính kèm tập tin",
              onclick: "document.getElementById('myFile').click()",
              icon: "pi pi-paperclip",
              style: {"margin-right":"2vw","width":"15vw"}
            }),
            _createVNode(_component_Button, {
              label: "Gởi đề tài",
              type: "button",
              icon: "pi pi-send",
              align: "center",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.upload())),
              disabled: $setup.loadingBar||!$setup.valid(),
              style: {"width":"15vw"}
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("form", _hoisted_24, [
              _createElementVNode("input", {
                id: "myFile",
                type: "file",
                style: {"display":"none"},
                accept: ".xls,.xlsx,.doc,.docx,.pdf",
                name: "files",
                multiple: "multiple",
                onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.fileChange($event.target.files))),
                disabled: $setup.loadingBar
              }, null, 40, _hoisted_25)
            ])
          ])
        ]),
        ($setup.listFileName.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_DataTable, {
                value: $setup.listFileName,
                showGridlines: "",
                responsiveLayout: "scroll",
                style: {"font-size":"13px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "nameFile",
                    header: "Tập tin"
                  }),
                  _createVNode(_component_Column, {
                    field: "",
                    header: "",
                    style: {"width":"20px"}
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_Dialog, {
            header: "Gởi đề tài",
            visible: $setup.loadingBar,
            "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.loadingBar) = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_ProgressBar, {
                  mode: "indeterminate",
                  style: {"height":".3em"}
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_ConfirmDialog)
        ])
      ])
    ]),
    _: 1
  }))
}